import { useEffect, useState } from 'react';
import { RiftboundAlertDialog } from '../ui/alert-dialog';
import { useAuth } from '../../hooks/useAuth';
import { useModals } from '../../hooks/useModals';
import {
  GUEST_SCAN_ADD_CANCEL,
  GUEST_SCAN_ADD_TITLE,
  GUEST_SCAN_CREATE_ACCOUNT,
  GUEST_SCAN_DISMISS_CANCEL,
  GUEST_SCAN_DISMISS_TITLE,
  guestScanAddDescription,
  GUEST_SCAN_DISMISS_BLURB,
} from '../../constants/guestExperienceCopy';
import {
  beginGuestScanAccountCreation,
  clearGuestScanPrompt,
  getGuestScanPrompt,
  hideGuestScanPrompt,
  subscribeGuestScanPrompt,
  type GuestScanPromptSnapshot,
} from '../../scan/guestScanAccountPrompt';

/**
 * Account ask for the guest scanner. Mounted beside the scan route so the
 * dismiss prompt survives leaving `/collection/scan`.
 */
export function GuestScanAccountPromptHost() {
  const { user } = useAuth();
  const { openSignIn } = useModals();
  const [prompt, setPrompt] = useState<GuestScanPromptSnapshot>(getGuestScanPrompt);

  useEffect(() => subscribeGuestScanPrompt(() => setPrompt(getGuestScanPrompt())), []);

  useEffect(() => {
    if (user) hideGuestScanPrompt();
  }, [user]);

  const isAdd = prompt.kind === 'add';

  return (
    <RiftboundAlertDialog
      open={prompt.kind != null}
      title={isAdd ? GUEST_SCAN_ADD_TITLE : GUEST_SCAN_DISMISS_TITLE}
      description={
        isAdd
          ? guestScanAddDescription(prompt.pendingAdd?.card.name)
          : GUEST_SCAN_DISMISS_BLURB
      }
      confirmLabel={GUEST_SCAN_CREATE_ACCOUNT}
      cancelLabel={isAdd ? GUEST_SCAN_ADD_CANCEL : GUEST_SCAN_DISMISS_CANCEL}
      confirmTreatment="primary"
      onClose={() => {
        // Confirm closes the dialog after arming the save. Only a real
        // dismiss (Not now, escape) should drop a pending card.
        if (getGuestScanPrompt().kind) clearGuestScanPrompt();
      }}
      onConfirm={() => {
        beginGuestScanAccountCreation();
        openSignIn();
      }}
    />
  );
}
